import { PrebidModuleDTO } from 'features/globalSetup/api/types/prebidModule'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const PREBID_MODULE_FOR_SELECT_FRAGMENT: TypedDocumentNode<PrebidModuleDTO> = gql`
  fragment PrebidModuleForSelectFragment on PrebidModule {
    id
    name
    demand
  }
`
